import { Chat_content } from "../../../Components/MessageApp/MessagesInterfaces";

import BlankPfp from "./Avatars/PlainAvatar.jpg";
import SisterAnaPfp from "./Avatars/SisterAnaPfp.webp";

export const VaticanMessageContent: Chat_content[] = [
  {
    icon: BlankPfp,
    name: "+390649183792",
    type: "individual",
    read: false,
    messages: [
      {
        content: {
          type: "text",
          content:
            "Hi, I’ve thought long and hard about our conversation last week and I want to help you. I’ve held onto some information for a long long time that I know you will want and I think it’s morally the right thing to share it with you. I have time on Sunday. Please tell me how we can meet so that we can sit down to discuss this properly. Irene",
        },
        timestamp: "2025-03-13T09:04:00Z",
        from: "Me",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Thank you so much for getting in touch, Sister. From the bottom of my heart I promise you’re doing the right thing. Meet me outside the Villa Farnesina at 2pm and I’ll walk you to my apartment. Please confirm if that works for you? Bests x",
        },
        timestamp: "2025-03-13T09:12:00Z",
        from: "+390649183792",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Yes that works. Irene",
        },
        timestamp: "2025-03-13T09:41:00Z",
        from: "Me",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Perfect. See you then.",
        },
        timestamp: "2025-03-13T09:42:00Z",
        from: "+390649183792",
        status: "Read",
      },

      {
        content: {
          type: "text",
          content:
            "Thank you for meeting me today. I know Bishop Tedesco was a personal friend of yours, so I’m sure talking about his disappearance must have brought back terrible memories of his loss. Please look after yourself this evening and get some good rest. As we discussed, I would love to follow up on this meeting next Sunday. Feel free to come directly to my apartment this time. Look out to make sure you’re not being followed. Take care x",
        },
        timestamp: "2025-03-16T18:48:00Z",
        from: "+390649183792",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Thank you. See you next Sunday. Irene",
        },
        timestamp: "2025-03-16T19:44:00Z",
        from: "Me",
        status: "Read",
      },

      {
        content: {
          type: "text",
          content:
            "Thanks for meeting me again, Sister. Your information is revelatory and I’m already writing and finding the right contacts to go public with this. Bests x",
        },
        timestamp: "2025-03-23T18:32:00Z",
        from: "+390649183792",
        status: "Read",
      },

      {
        content: {
          type: "text",
          content:
            "I have more to add to our conversation on Sunday. It’s about Attard. I want to pass you some further concrete evidence against him. Are you available tomorrow evening? Irene",
        },
        timestamp: "2025-03-26T21:11:00Z",
        from: "Me",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Good evening, Sister. Can you meet me at Teatro Ghione at 6pm tomorrow?",
        },
        timestamp: "2025-03-26T21:27:00Z",
        from: "+390649183792",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "God bless you. Yes I will see you there. Irene",
        },
        timestamp: "2025-03-26T21:31:00Z",
        from: "Me",
        status: "Read",
      },

      {
        content: {
          type: "text",
          content:
            "Good morning, I’m worried I was followed to the theater yesterday by one of the Swiss Guards. If the guards know, all of my enemies in the Vatican will know that I’m up to something. What should I do? Irene",
        },
        timestamp: "2025-03-28T10:42:00Z",
        from: "Me",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Good morning Irene, try to keep calm. I think I have all the information I need already, so you won’t need to sneak out anymore. If you keep a low profile, hopefully you won’t be detected. Keep me updated if you have any more suspicions. Love x",
        },
        timestamp: "2025-03-28T11:13:00Z",
        from: "+390649183792",
        status: "Read",
      },

      {
        content: {
          type: "text",
          content:
            "Sister Irene, I need some factual confirmation for my writing. Please confirm what date Sister Bermúdez first spoke to you about Giorgio Corsi and Attard? Bests x",
        },
        timestamp: "2025-03-30T15:21:00Z",
        from: "+390649183792",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "I remember it was in early 2022 but I can’t remember the exact date. Irene",
        },
        timestamp: "2025-03-30T15:41:00Z",
        from: "Me",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "That’s fine thank you Sister.",
        },
        timestamp: "2025-03-30T15:44:00Z",
        from: "+390649183792",
        status: "Read",
      },

      {
        content: {
          type: "text",
          content:
            "Good morning sister, more fact checking: can you confirm when Attard admitted to you that he killed Mario? Love x",
        },
        timestamp: "2025-04-02T10:57:00Z",
        from: "+390649183792",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Hi, he let it slip in an angry tirade on Sunday 23 February, 2025. Irene",
        },
        timestamp: "2025-04-02T12:16:00Z",
        from: "Me",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Thanks again, Sister.",
        },
        timestamp: "2025-04-02T12:20:00Z",
        from: "+390649183792",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "As always it’s you who should be thanked. Irene",
        },
        timestamp: "2025-04-02T12:20:00Z",
        from: "Me",
        status: "Read",
      },

      {
        content: {
          type: "text",
          content:
            "I’ve seen you’re on the news, I hope you’re ok, Sister. Sending well wishes x",
        },
        timestamp: "2025-04-05T07:57:00Z",
        from: "+390649183792",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Thank you for the warm message. I’m sure it’s an empty threat. Those mafia thugs need to know their atrocious deeds don’t have our support. By the way, have you found Marcello Pautasso’s denunciation? Irene",
        },
        timestamp: "2025-04-05T08:05:00Z",
        from: "Me",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Yes, I found it. Scandalous! Thanks again x",
        },
        timestamp: "2025-04-05T08:08:00Z",
        from: "+390649183792",
        status: "Read",
      },

      {
        content: {
          type: "text",
          content:
            "I’ve seen you’re on the news again, sister. You have my support as always x",
        },
        timestamp: "2025-04-10T08:13:00Z",
        from: "+390649183792",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Thank you again for the message. These stories are lies being spread by Vera Domus bank because of my stance on gay marriage. Thankfully the Pope trusts me. Irene",
        },
        timestamp: "2025-04-10T08:18:00Z",
        from: "Me",
        status: "Read",
      },

      {
        content: {
          type: "text",
          content:
            "Good afternoon, sister. I know this weekend is very special for you, but I was wondering if you could meet me to discuss our options for publication? Perhaps on Saturday? A trusted news platform has given me a date for publication that I like, but I want to run this by you first. All the best x",
        },
        timestamp: "2025-04-16T15:46:00Z",
        from: "+390649183792",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Good afternoon. Yes I can meet you on Saturday morning. Irene",
        },
        timestamp: "2025-04-16T15:58:00Z",
        from: "Me",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Brilliant. Meet me at the Ottaviano Metro stop, 10am.",
        },
        timestamp: "2025-04-16T16:09:00Z",
        from: "+390649183792",
        status: "Read",
      },

      {
        content: {
          type: "text",
          content:
            "I’m so sorry to do this Sister but some family stuff has come up and I need to travel to Bergamo today. Can we postpone tomorrow’s meeting until next week? Bests x",
        },
        timestamp: "2025-04-18T09:14:00Z",
        from: "+390649183792",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "I have a return flight booked for Monday morning so I will be available from Monday afternoon.",
        },
        timestamp: "2025-04-18T09:27:00Z",
        from: "+390649183792",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Sister, I hope you got these messages?",
        },
        timestamp: "2025-04-18T18:47:00Z",
        from: "+390649183792",
        status: "Read",
      },
    ],
  },
  {
    icon: SisterAnaPfp,
    name: "Sister Ana",
    type: "individual",
    read: true,
    messages: [
      {
        content: {
          type: "text",
          content: "Psalm 23:1 - 'The Lord is my shepherd; I shall not want.'",
        },
        timestamp: "2025-02-27T08:51:00Z",
        from: "Sister Ana",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Matthew 5:14 - 'Ye are the light of the world. A city that is set on a hill cannot be hid.",
        },
        timestamp: "2025-02-28T08:43:00Z",
        from: "Me",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Philippians 4:13 - 'I can do all things through Christ which strengtheneth me.'",
        },
        timestamp: "2025-03-02T07:13:00Z",
        from: "Me",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Galatians 5:22-23 - ' But the fruit of the spirit is love, joy, peace, longsuffering, gentleness, goodness, faith, meekness, temperance: against such there is no law.'",
        },
        timestamp: "2025-03-08T09:06:00Z",
        from: "Sister Ana",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Matthew 7:7 - 'Ask, and it shall be given you; seek, and ye shall find; knock, and it shall be opened unto you'",
        },
        timestamp: "2025-03-10T08:32:00Z",
        from: "Me",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Colossians 3:23 - 'Which things have indeed a shew of wisdom in will worship, and humility, and neglecting of the body: not in any honour to the satisfying of the flesh.'",
        },
        timestamp: "2025-03-15T09:02:00Z",
        from: "Sister Ana",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Exodus 14:14 - 'The Lord shall fight for you, and ye shall hold your peace.",
        },
        timestamp: "2025-03-16T08:38:00Z",
        from: "Sister Ana",
        status: "Read",
      },
    ],
  },
];
